import { FunctionComponent } from 'react';
import { usePropertyPageQuery } from '../../graphql/usePropertyPageQuery';
import { MediaShowcaseBrick, SingleItem, SplitItems } from './MediaShowcaseBrick';

import { ApiShowcaseItems, ApiSplitItems, ApiListingItem, ApiAerialItem } from './types';
import { mapApiWebLinkToWebLinkProps } from '../../../app-kit/components/WebLink/helpers/mapApiWebLinkToWebLinkProps';

export const MediaShowcaseBrickWithData: FunctionComponent = () => {
  const mediaShowcaseV2 = usePropertyPageQuery()?.data?.propertyPageBySlugV3?.mediaShowcaseV2;
  if (!mediaShowcaseV2) return null;

  const { mediaCounts, items } = mediaShowcaseV2;

  const isApiSplitItems = (items: ApiShowcaseItems): items is ApiSplitItems => {
    return items.__typename === 'PropertyPage_MediaShowcaseV2_SplitItems';
  };

  const isApiAerialItem = (item: ApiListingItem | ApiAerialItem): item is ApiAerialItem => {
    return item.__typename === 'PropertyPage_MediaShowcaseV2_AerialItem';
  };

  let showcaseItemsWithWebLinkProps: SplitItems | SingleItem;

  if (isApiSplitItems(items)) {
    showcaseItemsWithWebLinkProps = {
      ...items,
      main: {
        ...items.main,
        searchByImageButton: items.main.searchByImageButton
          ? mapApiWebLinkToWebLinkProps(items.main.searchByImageButton)
          : null,
      },
      secondary: {
        ...(isApiAerialItem(items.secondary)
          ? { ...items.secondary }
          : {
              ...items.secondary,
              searchByImageButton: items.secondary.searchByImageButton
                ? mapApiWebLinkToWebLinkProps(items.secondary.searchByImageButton)
                : null,
            }),
      },
      tertiary: {
        ...items.tertiary,
        searchByImageButton: items.tertiary.searchByImageButton
          ? mapApiWebLinkToWebLinkProps(items.tertiary.searchByImageButton)
          : null,
      },
    };
  } else {
    showcaseItemsWithWebLinkProps = {
      ...(isApiAerialItem(items)
        ? { ...items }
        : {
            ...items,
            searchByImageButton: items.searchByImageButton
              ? mapApiWebLinkToWebLinkProps(items.searchByImageButton)
              : null,
          }),
    };
  }

  return <MediaShowcaseBrick mediaCounts={mediaCounts} items={showcaseItemsWithWebLinkProps} />;
};
